import React, { ReactNode } from 'react';
import { useTranslate } from 'nucleus-text';
import useTheme from '@hooks/useTheme';
import ErrorState from '../ErrorState';
import PermissionErrorImage from './PermissionErrorImage';

interface PermissionErrorProps {
  image?: ReactNode;
  title?: string;
  subtitle?: string;
  hideAdditionalInfo?: boolean;
}

function PermissionError({ image, title, subtitle, hideAdditionalInfo = true }: PermissionErrorProps): JSX.Element {
  const { palette } = useTheme();
  const { translate } = useTranslate();

  const defaultImage = image || <PermissionErrorImage color={palette?.secondary.seedColor} />;
  const defaultTitle = title || translate('Error-Page-Permission-Title');
  const defaultSubtitle = subtitle || translate('Error-Page-Permission-Subtitle');

  return (
    <div css={{ maxWidth: 800, margin: 'auto' }}>
      <ErrorState
        image={defaultImage}
        title={defaultTitle}
        subtitle={defaultSubtitle}
        hideAdditionalInfo={hideAdditionalInfo}
      />
    </div>
  );
}

export default PermissionError;
